import axios from "axios";
import localdataService from "../services/localdata.service";

const localDataKey = "code";

export default {
    install: (vue, config) => {
        console.log("installing axios as http with", config);
        const http = axios.create(config);
        http.interceptors.request.use(config => {
            const value = localdataService.get(localDataKey);
            value && (config.headers["Mbk-Code"] = value);

            return config;
        });

        vue.http = http;
    }
}


// WEBPACK FOOTER //
// ./_common/plugins/http.plugin.js